import filterdate from "../../../assets/selectDate.png";
import filterall from "../../../assets/filterAll.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function ViewGroups() {
  const { t } = useTranslation();
  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I view all group transactions?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.Ikimina.viewGroups.step1")}
        </p>
        <p>
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.Ikimina.viewGroups.step2.part1")}
          {t("helpCenter.Ikimina.viewGroups.step2.part2")}
          <br />
          <span className="font-semibold">Note: </span>
          <ul className="list-disc pl-8">
            {" "}
            <li>
              {t("helpCenter.Ikimina.viewGroups.step2.note1.part1")}
              <img
                src={filterdate}
                alt="icon"
                className="inline-flex w-32"
              />{" "}
              {t("helpCenter.Ikimina.viewGroups.step2.note1.part2")}
            </li>
            <li>
              {t("helpCenter.Ikimina.viewGroups.step2.note2.part1")}
              <img src={filterall} alt="icon" className="inline-flex w-20" />
              {t("helpCenter.Ikimina.viewGroups.step2.note2.part2")}
            </li>
          </ul>
        </p>
        <br />
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.Ikimina.viewGroups.step3.part1")}
          <br />
          <span className="font-semibold">Note: </span>
          <ul className=" list-disc pl-8">
            {" "}
            <li>
              {t("helpCenter.Ikimina.viewGroups.step3.note1.part1")}
              <img
                src={filterdate}
                alt="icon"
                className="inline-flex w-32"
              />{" "}
              {t("helpCenter.Ikimina.viewGroups.step3.note1.part2")}
            </li>
            <li>
              {t("helpCenter.Ikimina.viewGroups.step3.note2.part1")}
              <img src={filterall} alt="icon" className="inline-flex w-20" />
              {t("helpCenter.Ikimina.viewGroups.step3.note2.part2")}
            </li>
          </ul>
        </p>
        <p></p>
      </section>
      <FeedBack />
    </article>
  );
}

export default ViewGroups;
